export default __webpack_public_path__ + "02b73517d57e43e18b1d2a2f91b1f664.svg";